/*=========================================================================================
  File Name: moduleEmployeeActions.js
  Description: Employee Module Actions
==========================================================================================*/

import employeeCardGql from "@/http/requests/card/employee_gql";
import employeeInsideGql from "@/http/requests/inside/employee_gql";

export default {
	setEmployeesSearchQuery({ commit }, query) {
		commit("SET_EMPLOYEES_SEARCH_QUERY", query);
	},

	fetchEmployeesManagement({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeInsideGql
				.fetchEmployees(payload)
				.then(response => {
					commit("SET_EMPLOYEES", response.employees);
					commit("SET_TOTAL_EMPLOYEES", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addEmployee({ state, commit }, employee) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.addEmployee(employee)
				.then(response => {
					// commit(
					// 	"ADD_EMPLOYEE",
					// 	Object.assign(employee, { id: response.id })
					// );
					commit("SET_TOTAL_EMPLOYEES", state.total + 1);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateEmployee({ commit }, employee) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.updateEmployee(employee)
				.then(response => {
					commit("UPDATE_EMPLOYEE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteEmployee({ state, commit }, employeeId) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.deleteEmployee(employeeId)
				.then(response => {
					commit("DELETE_EMPLOYEE", employeeId);
					commit("SET_TOTAL_EMPLOYEES", state.total - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	blockAccount({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.blockAccount(payload)
				.then(response => {
					commit("UPDATE_EMPLOYEE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	createAccount({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.createAccount(payload)
				.then(response => {
					commit("UPDATE_EMPLOYEE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	resetPassword({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.resetPassword(payload)
				.then(response => {
					commit("UPDATE_EMPLOYEE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	confirmEmployeePoint({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.confirmEmployeePoint(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	createExtraPoint({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.createExtraPoint(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	updateExtraPoint({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.updateExtraPoint(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	deleteExtraPoint({ commit }, payload) {
		return new Promise((resolve, reject) => {
			employeeCardGql
				.deleteExtraPoint(payload)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
